import { TariffAdditionalMetadata } from "../../../shared/src/Types/Types.ts";
import styled from "styled-components";
import { Button } from "../../../shared/src/Components/Button.tsx";
import { VStack } from "../../../shared/src/Components/Stacks.ts";
import { Modal, usePopup } from "../../../shared/src/Components/Modal.tsx";
import { TextSkeleton } from "../../../shared/src/Components/Typography.ts";

const Container = styled.div`
    border-radius: var(--border-radius);
    border: var(--border-width) solid var(--border);
    padding: var(--spacing-12);
`;

function TariffCard({
    tariff,
    isLoading,
    hasSubscryptoInstalled,
    hasSubscryptoConnected,
}:
    | {
          tariff: TariffAdditionalMetadata;
          isLoading?: false;
          hasSubscryptoInstalled: boolean | undefined;
          hasSubscryptoConnected: boolean;
      }
    | {
          // if tariff is provided, isLoading must be false
          tariff?: never;
          isLoading: true;
          hasSubscryptoInstalled?: never;
          hasSubscryptoConnected?: never;
      }) {
    const { isVisible, isFadingOut, isOpen, isShrinking, togglePopup } = usePopup();

    return (
        <>
            {!isLoading ? (
                <>
                    <Modal
                        isOpen={isOpen}
                        isShrinking={isShrinking}
                        isVisible={isVisible}
                        isFadingOut={isFadingOut}
                        onClose={togglePopup}
                    >
                        {!hasSubscryptoInstalled ? (
                            <h1>Чтобы подписаться, вам нужно наше расширение!</h1>
                        ) : !hasSubscryptoConnected ? (
                            <h1>Чтобы подписаться, вам нужно подулючить ваш кошелёк!</h1>
                        ) : (
                            <></>
                        )}
                    </Modal>
                    <Container>
                        <VStack gap={"6"}>
                            <h1>{tariff.title}</h1>
                            <p>
                                {tariff.price}/{tariff.periodicity}
                            </p>
                            <p>{tariff.description}</p>
                            <Button
                                variant={"primary"}
                                onClick={() => {
                                    console.log("hasSubscryptoInstalled", hasSubscryptoInstalled);
                                    console.log("hasSubscryptoConnected", hasSubscryptoConnected);
                                    togglePopup();
                                    // if (!hasSubscryptoInstalled || !hasSubscryptoConnected) {
                                    //     togglePopup()
                                    // } else {
                                    // }
                                }}
                            >
                                Подписаться
                            </Button>
                        </VStack>
                    </Container>
                </>
            ) : (
                <>
                    <Container>
                        <VStack gap={"6"}>
                            <TextSkeleton variant={"h1"} width_percentage={65} />
                            <TextSkeleton variant={"p"} width_percentage={40} />
                            <TextSkeleton variant={"p"} width_percentage={100} />
                            <Button variant={"primary"} disabled={true}>
                                {/*<TextSkeleton variant={"p"} width={100}/>*/}
                            </Button>
                        </VStack>
                    </Container>
                </>
            )}
        </>
    );
}

export default TariffCard;
